module.exports = __webpack_public_path__ + "img/patients-main-phone.a58edb11.webp";